import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(1.5),
  },
  discountBadge: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
  },
  planDetailRow: {
    padding: theme.spacing(0),
  },
}))
